import { IRequestEndpoint } from '../../../shared/models/request.model';

export class ICallableParams {
    constructor(
        public endpoint?: IRequestEndpoint,
        public ClavePromo?: string,
        public pedidos?: Array<IProductos>,
        public promos?: IPromosEcommerce[]
    ) { }
}

export class IRespCallableGeneric {
    constructor(
        public success: boolean,
        public status: string,
        public message: string,
    ) { }
}

export interface IProductAnalytics {
    promo_termina_en?: string;
    impactos_disponibles?: number;
    impactos_agotados?: boolean;
    puntos_por_compra?: number;
}

export interface IProductPortfolio {
    semana?: number;
    anio?: number;
    prioridad?: number;
    pendientes_cajas_sio?: number;
    avance_cajas_sio?: number;
    pendiente_cajas_sio?: number;
    bandera_recompra?: number;
    impacto_recompra?: number;
    puntos_recompepsi?: number | null;
    llave_mpts?: string;
    fecha_actualizacion?: string;
    portafolio?: boolean;
    modelo?: number;
}

export interface IProductos extends IProductPortfolio, IProductAnalytics {
    id_producto?: number
    title?: string
    subtitle?: string
    imagen?: string
    precio?: number
    price_info?: number;
    productos?: number
    sku?: string
    descripcion?: string
    familia?: string
    marca?: string
    segmento?: string
    presentacion?: string
    TipoEnvase?: string;
    clave_producto?: number
    nombre_producto?: string
    taste?: string
    precio_original?: number;
    ClavePromo?: string;
    Maximo?: number;
    Minimo?: number;
    Nivel?: number;
    FactorCl?: number;
    Etiquetados?: boolean;
    Multiplicador?: number;
    KeyEtiquetados?: string;
    TotalEnCaja?: number;
    ID_Categoria_GETM?: string;
    Categoria_GETM?: string;
    Prioridad_Categoria_GETM?: number;
    ID_Agrupador_GETM?: string;
    Agrupador_GETM?: string;
    Prioridad_Agrupador_GETM?: number;
    Retornabilidad?: string;
    isCarrito?: boolean;
    isRemove?: boolean;
    isEdit?: boolean;
    isNew?: boolean;
    newAdd?: number;
    tipo?: string;
    price_discount?: number | null;
    discount_type?: string | null;
    discType?: number | null;
    discId?: number | null;
    discLevel?: number | null;
    puntos_recompepsi?: number | null;
    muestra_texto_generico_puntos?: boolean;
}

export interface IGruposEtiquetados {
    group: IProductos[];
    isValid: boolean;
}

export interface IResumeOrder {
    id_pedido: number;
    numero_pedido: string;
    creation_date: string;
    price_info: number;
    quantity: number;
    status: string;
    ship_on_date: string;
}

export interface IRespProductos extends IRespCallableGeneric {
    data: [
        IProductos[],
        IGroup[],
        IProductos[]?,
        IProductos[]?,
        IRecommender[]?,
        ICategories[]?,
        IGroupers[]?,
        IProductos[]?,
    ];
}

export interface IGroup {
    descripcion: string
}

export interface IRecommender {
    Modelo?: number | null;
    Recomendador: string;
    Prioridad: number;
}

export interface ICategories {
    ID_Categoria_GETM: string;
    Categoria_GETM: string;
    Imagen: string;
}

export interface IGroupers {
    ID_Categoria_GETM: string;
    ID_Agrupador_GETM: string;
    Agrupador_GETM: string;
    Imagen: string;
}

export type FavsItems = Partial<IProductos> & Partial<IPromosEcommerce>;

export interface ISearchFilter extends FavsItems {
    id: number | string;
    recommender?: number;
};

/**
 * Promociones ecommerce
 */

export interface IResultPromosEcommerce extends IRespCallableGeneric {
    data: IPromosEcommerce[];
}

export type T_TipoPromocion = 'ESTATICO' | 'ESCALERA' | 'DINAMICO' | 'BONIFICACION';

export interface IPromosEcommerce {
    ID_Promocion: number;
    TipoPromocion: T_TipoPromocion;
    ClavePromo: string;
    ID_Bodega: number;
    imagen_url: string;
    Vigencia: number;
    Promocion: string;
    Contenido: string;
    PaquetesCanjeados: number;
    MaximoPaquetes: number;
    UltimosCanjeados: number;
    PrecioOriginal: number;
    PrecioDescuento: number;
    TotalNiveles: number;
    Niveles: INivelesPromo[];
    Productos?: Array<IProductos>;
    Marcas?: Array<{ Marca: string; URL_Imagen: string; }>;
    ViewImagePromo?: boolean;
    Color: string;
    Exclusivo: boolean;
    Bonificacion?: boolean;
    BonusRedeem?: boolean;
    CartAuto?: boolean;
    Sunday?: boolean;
    FechaVigenciaFinal?: string;
    isCarrito?: boolean;
    isEdit?: boolean;
    isNew?: boolean;
    newAdd?: number;
    puntos_recompepsi?: number | null;
    muestra_texto_generico_puntos?: boolean;
}

export interface ISummaryPricePromo {
    ClavePromo: string;
    total_precio_descuento: number;
    total_precio: number;
    total_descuento: number;
}

export interface INivelesPromo {
    Nivel: number;
    Minimo: number;
    Maximo: number;
    Descuento: number;
    Cumple?: boolean;
}

export enum EDefultCanje {
    DINAMICO = 1,
    ESTATICO = 1,
    ESCALERA = 1,
    BONIFICACION = 1
}

/**
 * Productos de promociones ecommerce
 */
export interface IResultProductPromo extends IRespCallableGeneric {
    data: IProductos[];
}

/**
 * Guardado del Carrito
 */
export interface IResultSendCart extends IRespCallableGeneric {
    data: {
        ID_Carrito: number;
    };
}

/**
 * Envio del pedido
 */

export interface IResultSendOrder {
    success: boolean;
    message: string;
    status: string;
    data: IRespOrder[];
}
export interface IRespOrder extends IResumeOrder {
    regFh?: string;
    fhUltAct?: string;
    fhEnt?: string;
    nombre?: string;
    fecha_despacho: string;
    fecha_despacho_copy?: string;
    fecha_entrega_copy?: string;
    fecha_entrega?: string;
    tokens?: string;
    detalle?: IProductos[];
    tendero_aplica_recompepsi?: boolean;
    puntos_recompepsi_totales?: number;
}

export interface IResultDetailOrder extends IRespCallableGeneric {
    data: IDataDetailOrder;
}
export interface IDataDetailOrder {
    Productos: DetalleProductos[];
    Promos: IPromosEcommerce[];
    ProductsPromos: DetalleProductos[];
}

export interface CarritoActualEntity {
    ID_Carrito: number;
    detalle?: DetalleProductos[];
    Promos?: IPromosEcommerce[];
    ProductsPromos?: DetalleProductos[];
}
export interface PedidoActualEntity {
    id_pedido: number;
    numero_pedido: string;
    price_info: number;
    quantity: number;
    status: number;
    ship_on_date: string;
    creation_date: string;
    limit_date: string;
    fecha_entrega_copy: string;
    fecha_registrado_estatus: string;
    fecha_despacho_estatus: string;
    fecha_ruta_estatus: string;
    listStatus?: IStatus[];
    detalle?: DetalleProductos[];
    Promos?: IPromosEcommerce[];
    ProductsPromos?: DetalleProductos[];
}
export interface DetalleProductos {
    id_producto: number;
    quantity: number;
    price_info: number;
    unit_price: number;
    title: string;
    subtitle: string;
    imagen: string;
    flavors: string;
    ClaveProducto: number;
    ClavePromo?: string;
    precio_original?: number;
    Minimo?: number;
    Maximo?: number;
    Nivel?: number;
    modelo?: number;
    marca?: string;
    segmento?: string;
    familia?: string;
    nombre_producto?: string;
    presentacion?: string;
    TipoEnvase?: string;
    FactorCl?: number;
    Etiquetados?: boolean;
    Multiplicador?: number;
    KeyEtiquetados?: string;
    TotalEnCaja?: number;
    Retornabilidad?: string;
    price_discount?: number;
    discount_type?: string;
    discType?: number;
    discId?: number;
    discLevel?: number;
}
export interface PedidoHistoricoEntity extends IResumeOrder {
    detalle?: DetalleHistoricoProductos[];
}
export interface DetalleHistoricoProductos {
    ProductID: string;
    quantity: number;
    price_info: number;
    unit_price: number;
    title: string;
    subtitle: string;
    imagen: string;
    flavors: string;
}
export interface IStatus {
    class: string;
    dateField?: string;
    iconDisabled?: string;
    iconEnabled?: string;
    title: string;
    titleColor?: string;
    urlIcon?: string;
}

export interface IResultCurrentOrders extends IRespCallableGeneric {
    data: IDataCurrentOrders
}
export interface IDataCurrentOrders {
    carrito_actual?: CarritoActualEntity[]
    pedido_actual?: PedidoActualEntity[]
}

export interface IResultHistoricalOrders extends IRespCallableGeneric {
    successful?: boolean
    data: IDataHistoricalOrders
}
export interface IDataHistoricalOrders {
    ID_Bodega?: number
    NUD?: number
    pedido_historico?: PedidoHistoricoEntity[]
}

export interface IResultEcommerceConfig extends IRespCallableGeneric {
    data: IDataEcommerceConfig
}
export interface IDataEcommerceConfig {
    PromoModulo?: boolean
    frecuencia_entrega: string
    fecha_entrega?: string
    Responsable?: string
    Telefono?: string
    HOY?: string
    fecha_entrega_copy?: string
    LimitMinMonto?: number | null
    LimitMinCajas?: number | null
    LimitMaxMonto?: number | null
    LimitMaxCajas?: number | null
    LimiteMinAdvertencia?: number | null
    ID_Programa: number
    ImagenProductoDefault?: string
}

/**
 * Cancela Pedidos
 */
export interface IResultCancelaPedidos extends IRespCallableGeneric {
    data: IDataCancelaPedidos;
}

export interface IDataCancelaPedidos {
    id_pedido: number;
    regFh: string;
    fhUltAct: string;
    fhEnt: string;
    numero_pedido: string;
}

/**
 * Manda informaión al Webhook
 */
export class ISendWebhookParams {
    constructor(
        public evento: 'pedido_nuevo' | 'token_expirado' | 'inactividad_webview' | 'carrito_abandonado',
        public idPedido: string,
        public metadata: Array<any>,
    ) { }
}
export interface IResultSendWebhook {
    success: boolean;
    message: string;
    status: string;
    data: IRespSendWebhook;
}
export interface IRespSendWebhook {
    error: boolean;
    descripcion: string;
    entrada: IRespWebhook;
    salida?: Array<any>;
}
export interface IRespWebhook extends ISendWebhookParams {
    id: string;
}

export interface ISummaryPrice {
    total_cajas: number;
    total_precio: number;
    precio_descuento: number;
    FactorCl?: number;
    puntos_recompepsi?: number;
}

export interface IGetmTiendaFavorito {
    principal: FavsItems;
    adicionales: FavsItems[];
}

export interface IGetmTiendaCategorias {
    products: IProductos[];
    categories: ICategories[];
    groupers: IGroupers[];
}

export interface IDataGetmTienda {
    fulldata: boolean;
    favoritos: IGetmTiendaFavorito[];
    tendencias: IProductos[];
    promos: IPromosEcommerce[];
    categorias: IGetmTiendaCategorias;
    ttl_segundos: number;
    _errors: { [key: string]: string };
}

export interface IResultGetmTienda extends IRespCallableGeneric {
    data: IDataGetmTienda;
}

export interface ISaveGetmStorage<T> {
    fecha: string;
    data: T;
    ttl_segundos: number;
}

